// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"2f5d09ad94cdd3ab","5285":"39229cfe7a636114"}[chunkId] + ".css";
};